import { PartnerAccountExistsResponse } from "../../../../shared/services/responses/partner-account-exists-response";

export class CreatePartnerAccountExistsDialogData {
  public partnerAccountExistsResponses: PartnerAccountExistsResponse[];

  constructor(partnerAccountExistsResponses: PartnerAccountExistsResponse[]) {
    this.partnerAccountExistsResponses = partnerAccountExistsResponses;
  }
}
